export const CONSTANTS = Object.freeze({
  APP_HEADER_BREAKPOINT: 1200,
  APP_DEFAULT_IMG: require('@/assets/img/src/img-box-default.jpg'),
  APP_MAP_MARKER_BASE_URL: 'http://maps.google.com/mapfiles/ms/icons/',
  APP_LISTING_STATUS: [
    {
      id: 1,
      title: 'New'
    },
    {
      id: 2,
      title: 'Pending'
    },
    {
      id: 3,
      title: 'In Progress'
    },
    {
      id: 4,
      title: 'Finished'
    },
    {
      id: 5,
      title: 'Canceled'
    },
  ],
  APP_YOUTUBE_PROFILE_URI: 'https://www.youtube.com/channel/UCHK9JdZIShJKFuvG3WYPbWw',
  APP_FACEBOOK_PROFILE_URI: 'http://facebook.com/taxappeals',
  APP_TWITTER_PROFILE_URI: 'https://twitter.com/ptdcorp',
});